<template>
  <auth-login/>
</template>

<script>
const AuthLogin = () => import('@/components/auth/AuthLogin')
export default {
  name: 'loginPage',
  components: {
    AuthLogin
  }
}
</script>
<style lang="scss" scoped>

</style>
